import styled from "styled-components";

export const EditingForm = styled.form`
  padding: 2.5rem;
  background-color: var(--white);
  background-color: var(--bright-blue);
  border-bottom: solid 1px var(--very-light-grayish-blue);
`;
